/**
 * ToastContainer — renders stacked MUI Snackbar/Alert toasts from the toast store.
 */

import { Snackbar, Alert, useMediaQuery, useTheme } from "@mui/material";
import { useToastStore } from "@/stores/toastStore";

export default function ToastContainer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const toasts = useToastStore((s) => s.toasts);
  const removeToast = useToastStore((s) => s.removeToast);

  return (
    <>
      {toasts.map((t, idx) => (
        <Snackbar
          key={t.id}
          open
          autoHideDuration={t.duration ?? 4000}
          onClose={() => removeToast(t.id)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: isMobile ? "center" : "right",
          }}
          sx={{
            bottom: {
              xs: `calc(env(safe-area-inset-bottom, 0px) + ${88 + idx * 72}px)`,
              sm: 24 + idx * 64,
            },
          }}
        >
          <Alert
            onClose={() => removeToast(t.id)}
            severity={t.severity}
            variant="filled"
            action={t.action}
            sx={{
              width: "100%",
              minWidth: { xs: "min(320px, calc(100vw - 32px))", sm: 280 },
              maxWidth: { xs: "calc(100vw - 32px)", sm: 420 },
            }}
          >
            {t.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
}
